import { render, staticRenderFns } from "./myDetail.vue?vue&type=template&id=8d7818f0"
import script from "./myDetail.vue?vue&type=script&lang=js"
export * from "./myDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports